import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AdminContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminProvider = ({ children }) => {
    const [admin, setAdmin] = useState(null);
    const [adminToken, setAdminToken] = useState(localStorage.getItem('admin_token'));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (adminToken) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${adminToken}`;
            fetchAdmin();
        } else {
            setLoading(false);
        }
    }, [adminToken]);

    const fetchAdmin = async () => {
        try {
            const response = await axios.get(`${API}/admin/me`);
            setAdmin(response.data);
        } catch (error) {
            console.error('Error fetching admin:', error);
            adminLogout();
        } finally {
            setLoading(false);
        }
    };

    const adminLogin = async (username, password) => {
        const response = await axios.post(`${API}/admin/login`, { username, password });
        const { access_token } = response.data;
        localStorage.setItem('admin_token', access_token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
        setAdminToken(access_token);
        setAdmin({ username, is_admin: true });
        return response.data;
    };

    const adminLogout = () => {
        localStorage.removeItem('admin_token');
        delete axios.defaults.headers.common['Authorization'];
        setAdminToken(null);
        setAdmin(null);
    };

    return (
        <AdminContext.Provider value={{ admin, adminToken, loading, adminLogin, adminLogout }}>
            {children}
        </AdminContext.Provider>
    );
};

export const useAdmin = () => {
    const context = useContext(AdminContext);
    if (!context) {
        throw new Error('useAdmin must be used within an AdminProvider');
    }
    return context;
};
